"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootAgentProfileSagas = void 0;
var effects_1 = require("redux-saga/effects");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var AgentProfileAction_1 = require("@/pages/agentProfile/actions/AgentProfileAction");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var WindowApi_1 = require("@/api/browser/WindowApi");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var getTestimonialCards = function (state) { return state.agentProfile.clientTestimonials; };
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initBioMore)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initTestimonialCardsMore)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(initTestimonialControls)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(initTransactionControls)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(initPropertiesFav)];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var initBioMore = function () {
    var parent, child;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                parent = document.getElementById('bio');
                child = parent.children.item(0);
                if (!(child.clientHeight > parent.clientHeight)) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.put(AgentProfileAction_1.default.setBioMore(true))];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
};
var initTestimonialCardsMore = function () {
    var agentTestimonials, cardsCount, i, parent, child;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getTestimonialCards)];
            case 1:
                agentTestimonials = _a.sent();
                cardsCount = agentTestimonials.length;
                i = 0;
                _a.label = 2;
            case 2:
                if (!(i < cardsCount)) return [3 /*break*/, 5];
                parent = document.getElementById("card-" + i);
                child = parent.children.item(0);
                if (!(child.clientHeight > parent.clientHeight)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(AgentProfileAction_1.default.setCardMore(i, true))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                i++;
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
var initTestimonialControls = function () {
    var payload, direction, elm, width;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.MOVE_TESTIMONIAL)];
            case 1:
                payload = (_a.sent()).payload;
                direction = payload;
                elm = document.getElementById('testimonials');
                width = Array.from(elm.children)[0].clientWidth;
                elm.scrollBy({ left: width * direction, behavior: 'smooth' });
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var initTransactionControls = function () {
    var payload, direction, elm, width;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.MOVE_TRANSACTION)];
            case 1:
                payload = (_a.sent()).payload;
                direction = payload;
                elm = document.getElementById('transactions');
                width = Array.from(elm.children)[0].clientWidth;
                elm.scrollBy({ left: width * direction, behavior: 'smooth' });
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var initPropertiesFav = function () {
    var ids;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 1:
                ids = _a.sent();
                return [4 /*yield*/, effects_1.put(AgentProfileAction_1.default.setPropertiesActive(ids))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchPropertyFavClick = function () {
    var payload, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.ON_PROPERTY_FAV_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                item = payload;
                if (!item.isSaved) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4: return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(item))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [4 /*yield*/, effects_1.call(initPropertiesFav)];
            case 9:
                _a.sent();
                return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
var watchPropertyEnquireClick = function () {
    var payload, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.ON_PROPERTY_ENQUIRE_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchPropertyItemClick = function () {
    var payload, item, lang, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.ON_PROPERTY_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, item.building, item.referenceId, item.type)];
            case 3:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchAgentProfileEnquireClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.ON_ENQUIRE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchAgentProfileMoreCardsClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(AgentProfileAction_1.default.ON_TESTIMONIAL_MORE_CARDS_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(200)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initTestimonialCardsMore)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var rootAgentProfileSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    watchPropertyFavClick: watchPropertyFavClick,
    watchPropertyEnquireClick: watchPropertyEnquireClick,
    watchPropertyItemClick: watchPropertyItemClick,
    watchAgentProfileEnquireClick: watchAgentProfileEnquireClick,
    watchAgentProfileMoreCardsClick: watchAgentProfileMoreCardsClick,
    watchInit: watchInit,
};
exports.rootAgentProfileSagas = rootAgentProfileSagas;
